import LyTab from './src/index.vue'

const install = function (Vue, config = {}) {
  if (install.installed) return

  Vue.component(LyTab.name, LyTab)
}

// auto install
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  LyTab
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ly-tab/index.js
// module id = 7HVg
// module chunks = 0